import { getAccessToken } from '@auth0/nextjs-auth0';
import { HomePage, HomePageProps } from '@features/home';
import { ServiceOffer } from '@services/offer';
import { getTranslations } from '@utils/i18n';
import { createGetServerSideProps, getLoggedUser } from '@utils/ssr';

export default HomePage;

export const getServerSideProps = createGetServerSideProps<HomePageProps>(
  async function ({ locale, req, res, query }) {
    let offers = null;
    let total = 0;
    const page = query.page ? Math.max(1, Number(query.page)) : 1;
    const size = query.size ? Math.max(1, Math.min(Number(query.size), 100)) : 10;

    const [translations, user] = await Promise.all([
      getTranslations(['common', 'home'], locale),
      getLoggedUser(req, res)
    ]);

    if (user) {
      const { accessToken } = await getAccessToken(req, res);
      const paginatedOffers = await ServiceOffer.getAll(page, size, {
        useAppProxy: false,
        token: accessToken
      });
      offers = paginatedOffers.data;
      total = paginatedOffers.total;
    }

    return {
      props: {
        ...translations,
        user,
        offers: offers ? JSON.parse(JSON.stringify(offers)) : null,
        total,
        page,
        size
      }
    };
  }
);
